import * as React from 'react';
import { Box } from '@mui/material';

export default function PrettyJson({ json }) {
  let value = json;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch (err) {
      // keep original string
    }
  }

  const text = typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value ?? '');

  return (
    <Box
      component="pre"
      sx={{
        m: 0,
        p: 1.5,
        overflow: 'auto',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.default',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        fontSize: 12,
        lineHeight: 1.45,
      }}
    >
      {text}
    </Box>
  );
}